import * as React from "react";

import { H1 } from "@blueprintjs/core";
import { css } from "glamor";

import { Grade, Juror } from "src/Interfaces";

import {
	changeGrade,
	changeGradeJuror,
	getCheckedOrUncheckedStages,
	getJurors,
	setGradeShouldCount,
	setStageChecked,
} from "../api";
import GradesCheckerCard from "./GradesCheckerCard";

import produce from "immer";

const styles = {
	container: css({ width: "100%", textAlign: "left", marginBottom: "20px" }),
	element: css({
		margin: "20px 0",
		textAlign: "left",
	}),
};

export default class GradesChecker extends React.Component<
	{},
	{ checkedStages: any; uncheckedStages: any; editingChecked: number | undefined; jurors: Juror[] }
> {
	private interval: any = null;
	public state = {
		checkedStages: {},
		uncheckedStages: {},
		editingChecked: undefined,
		jurors: [] as Juror[],
	};
	public async componentDidMount() {
		const jurors = Object.values(await getJurors()) as Juror[];
		const initialCheckedStages = await getCheckedOrUncheckedStages(true);
		const initialUncheckedStages = await getCheckedOrUncheckedStages(false);
		this.setState({
			checkedStages: initialCheckedStages,
			uncheckedStages: initialUncheckedStages,
			jurors,
		});
		this.interval = setInterval(async () => {
			if (typeof this.state.editingChecked === "undefined") {
				const checkedStages = await getCheckedOrUncheckedStages(true);
				const uncheckedStages = await getCheckedOrUncheckedStages(false);
				this.setState({ checkedStages, uncheckedStages });
			}
		}, 5000);
	}
	public componentWillUnmount() {
		clearInterval(this.interval);
	}
	private sendSetStageChecked = async (stageId: number) => {
		const result = await setStageChecked(stageId);
		const checkedStages = await getCheckedOrUncheckedStages(true);
		const uncheckedStages = await getCheckedOrUncheckedStages(false);
		this.setState({ checkedStages, uncheckedStages });
		return result;
	};
	private handleEditingChecked = async (id: number) => {
		const checkedStages = await getCheckedOrUncheckedStages(true);
		const uncheckedStages = await getCheckedOrUncheckedStages(false);
		if (this.state.editingChecked === id) {
			this.setState({ editingChecked: undefined, checkedStages, uncheckedStages });
			return;
		}
		this.setState({ editingChecked: id, checkedStages, uncheckedStages });
	};
	private onItemSelect = async (juror: Juror, stage_id: number, old_juror_id: number) => {
		const res = await changeGradeJuror(stage_id, old_juror_id, juror.id);
		console.log(res);
		if (res.success) {
			const checkedStages = await getCheckedOrUncheckedStages(true);
			const uncheckedStages = await getCheckedOrUncheckedStages(false);
			this.setState({ checkedStages, uncheckedStages });
			console.log("getting stages");
		}
	};

	private toggleGradesCount = async (stage_id: number, juror_id: number, shouldCount: boolean) => {
		const res = await setGradeShouldCount(stage_id, juror_id, shouldCount);

		if (res.success) {
			const checkedStages = await getCheckedOrUncheckedStages(true);
			const uncheckedStages = await getCheckedOrUncheckedStages(false);
			this.setState({ checkedStages, uncheckedStages });
		}
	};

	private onGradeChange = (
		newGrade: number,
		gradeData: Grade,
		gradeIndex: number,
		stageID: number,
		alreadyChecked: boolean
	) => {
		changeGrade(gradeData.grade!, newGrade, stageID, gradeData.participant_id, gradeData.juror_id);
		if (alreadyChecked) {
			this.setState(
				produce((state) => {
					state.checkedStages[stageID].grades[gradeIndex].grade = newGrade;
				})
			);
		} else {
			this.setState(
				produce((state) => {
					state.uncheckedStages[stageID].grades[gradeIndex].grade = newGrade;
				})
			);
		}
	};
	private makeStages = (stages: any, title: string, empty: string, checked: boolean) => (
		<div {...styles.container}>
			<H1>{title}</H1>
			{!stages.length ? (
				<div>{empty}</div>
			) : (
				stages.map((stage: any) => {
					return (
						<div key={stage.id} {...styles.element}>
							<GradesCheckerCard
								stage={stage}
								jurors={this.state.jurors}
								editing={this.state.editingChecked === stage.id}
								checked={checked}
								onToggleEditing={() => this.handleEditingChecked(stage.id)}
								onJurorSelect={(selectedJuror: Juror, old_juror_id: number) => {
									this.onItemSelect(selectedJuror, stage.id, old_juror_id);
								}}
								onToggleGradesCount={(juror_id: number, gradesCount: boolean) =>
									this.toggleGradesCount(stage.id, juror_id, !gradesCount)
								}
								onSetStageChecked={() => this.sendSetStageChecked(stage.id)}
								onGradeChange={this.onGradeChange}
							/>
						</div>
					);
				})
			)}
		</div>
	);
	public render() {
		const uncheckedStages = Object.values(this.state.uncheckedStages);
		const checkedStages = Object.values(this.state.checkedStages);
		return (
			<div>
				{this.makeStages(uncheckedStages, "Stages to check", "no unchecked Stages", false)}
				{this.makeStages(checkedStages, "Checked Stages", "", true)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/GradesChecker.tsx